/**
 * Theme manager — get/set/list + TG chrome sync.
 * Anti-FOUC script in layout.tsx reads the same localStorage key.
 */
import { syncChrome, forceLightVars, restoreDarkVars } from "./tg-theme";

export type ThemeName = "dark" | "light";

const KEY = "cg-theme";

export const THEMES: readonly { id: ThemeName; label: string; bg: string }[] = [
  { id: "dark", label: "Тёмная", bg: "#08090a" },
  { id: "light", label: "Светлая", bg: "#ffffff" },
];

export function getTheme(): ThemeName {
  if (typeof window === "undefined") return "dark";
  const stored = localStorage.getItem(KEY) as ThemeName | null;
  if (stored) return stored;
  // No explicit user choice yet — mirror ANTI_FOUC's fallback so the
  // React appearance state agrees with the data-theme attribute already
  // set on <html> (real Telegram colorScheme, or shot-tool mock).
  const tg = (window as unknown as { Telegram?: { WebApp?: { colorScheme?: string } } })
    .Telegram?.WebApp?.colorScheme;
  return tg === "light" ? "light" : "dark";
}

export function setTheme(name: ThemeName): void {
  localStorage.setItem(KEY, name);
  document.documentElement.setAttribute("data-theme", name);
  // Override inline --tg-theme-* vars so TGUI components adapt
  if (name === "light") forceLightVars();
  else restoreDarkVars();
  requestAnimationFrame(() => syncChrome());
}
